/**
 * The header's menus, fetched once the page has shown (sections/header.liquid).
 *
 * Pages carry the picture mega menus and the phone menu's screens empty. Their cards show each
 * collection's picture - its first product's when it has none of its own - and looking up those
 * few hundred products took most of the time every page spent being built. So they are asked
 * for on their own, from /?view=menus&section_id=<header> (the desktop's panels) and
 * /?view=menus-phone&section_id=<header> (the phone's screens), which Shopify caches like any
 * page, and handed to assets/machine-mega-menu.js and assets/mobile-drilldown.js. Each side asks
 * only for its own half, so neither waits for the other's pictures to be worked out.
 *
 * Where the desktop menu shows, its panels are fetched as soon as the page has been read - not
 * once every picture on it has loaded - and straight away if the pointer reaches the header
 * first, so a panel is ready by the time it is pointed at. On a phone, only once the menu
 * button is touched.
 */
(function () {
  var requests = {};

  /**
   * The menus were built for the home page, so none of their links is marked as the page being
   * looked at. Marks the ones that lead here, as the page's own menus would have.
   */
  function markCurrent(root) {
    var here = window.location.pathname.replace(/\/$/, "");
    Array.prototype.forEach.call(root.querySelectorAll("a[href]"), function (link) {
      var href = link.getAttribute("href");
      // "#" is a menu item with no link, not this page.
      var path = href.charAt(0) === "#" ? null : new URL(href, window.location.href).pathname.replace(/\/$/, "");
      if (path === here) {
        link.setAttribute("aria-current", "page");
      } else {
        link.removeAttribute("aria-current");
      }
    });
  }

  /** The phone menu's screens go straight into it; each is built when first opened. */
  function fillPhoneMenu(doc) {
    var drilldown = document.querySelector("mobile-drilldown[data-mdd-lazy]");
    if (!drilldown) return;
    Array.prototype.forEach.call(doc.querySelectorAll("template[data-mdd-template]"), function (template) {
      drilldown.appendChild(document.importNode(template, true));
    });
    drilldown.removeAttribute("data-mdd-lazy");
  }

  /**
   * Fetches one half of the menus, once: "desktop" (the default) or "phone". Resolves with the
   * fetched document; a failed fetch is tried again next time.
   */
  function load(part) {
    part = part === "phone" ? "phone" : "desktop";
    if (requests[part]) return requests[part];
    var attr = part === "phone" ? "data-menus-phone-url" : "data-menus-url";
    var header = document.querySelector("header[" + attr + "]");
    if (!header) return Promise.reject(new Error("The header has no menus to fetch"));

    var request = fetch(header.getAttribute(attr), { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Menus request failed: " + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        Array.prototype.forEach.call(doc.querySelectorAll("template"), function (template) {
          markCurrent(template.content);
        });
        if (part === "phone") fillPhoneMenu(doc);
        return doc;
      });
    request.catch(function () {
      if (requests[part] === request) delete requests[part];
    });
    requests[part] = request;
    return request;
  }

  window.headerMenus = { load: load };

  function boot() {
    var phoneButton = document.querySelector(".head-slot-nav-mobile-link");
    if (phoneButton && document.querySelector("mobile-drilldown[data-mdd-lazy]")) {
      var soon = function () {
        load("phone").catch(function () {});
      };
      phoneButton.addEventListener("touchstart", soon, { passive: true });
      phoneButton.addEventListener("pointerdown", soon);
      phoneButton.addEventListener("focus", soon);
    }

    if (!document.querySelector("[data-mm-lazy]")) return;

    // The desktop menu opens on hover, so its panels must be ready before they are asked for.
    var desktop = window.matchMedia("(min-width: 990px)");
    var now = function () {
      if (desktop.matches) load().catch(function () {});
    };

    // A pointer on its way to the menu starts the fetch at once.
    var header = document.querySelector("header[data-menus-url]");
    if (header) header.addEventListener("pointerenter", now, { once: true });

    // Otherwise as soon as the browser has a moment after reading the page. The request is
    // small; it is the server working the menus out that takes the time, so it starts early.
    var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 1); };
    idle(now, { timeout: 500 });

    // A page opened in a background tab gets little or no idle time; it fetches when looked at.
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") now();
    });

    // A window widened past the phone layout gets them too.
    if (desktop.addEventListener) desktop.addEventListener("change", now);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
